import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "darkIcon", "lightIcon"];

  connect() {
    if (!localStorage.getItem("color-theme")) {
      const prefersDark = window.matchMedia(
        "(prefers-color-scheme: dark)",
      ).matches;
      document.documentElement.classList.toggle("dark", prefersDark);
    } else {
      document.documentElement.classList.toggle(
        "dark",
        localStorage.getItem("color-theme") === "dark",
      );
    }

    document.documentElement.style.colorScheme =
      document.documentElement.classList.contains("dark") ? "dark" : "light";

    this.updateUI();
  }

  disconnect() {
    // No teardown required; theme state is handled through the document root.
  }

  toggle() {
    const isDark = document.documentElement.classList.contains("dark");
    document.documentElement.classList.toggle("dark", !isDark);
    localStorage.setItem("color-theme", isDark ? "light" : "dark");
    document.documentElement.style.colorScheme = isDark ? "light" : "dark";
    this.updateUI();
  }

  updateUI() {
    if (
      this.hasToggleTarget &&
      this.hasDarkIconTarget &&
      this.hasLightIconTarget
    ) {
      const isDark = document.documentElement.classList.contains("dark");

      if (isDark) {
        this.darkIconTarget.classList.add("hidden");
        this.lightIconTarget.classList.remove("hidden");
      } else {
        this.darkIconTarget.classList.remove("hidden");
        this.lightIconTarget.classList.add("hidden");
      }

      this.toggleTarget.setAttribute("aria-pressed", String(isDark));
      this.toggleTarget.setAttribute(
        "title",
        isDark ? "Switch to light mode" : "Switch to dark mode",
      );
    }
  }
}
